import React from "react";

class LobbyCTA extends React.Component {
  handleClick(e) {
    e.preventDefault();

    //Fire the handler if we're not disabled!
    if (!this.props.isDisabled) {
      this.props.handler();
    }
  }

  getCategoryClass() {
    if (this.props.isDisabledAppearance) {
      return "is-disabled";
    }

    if (this.props.isRedHot) {
      return "red-hot";
    }

    if (this.props.isReadyPressed) {
      return "ready-pressed";
    }
    if (this.props.isPrimary) {
      return "primary";
    }
    return "";
  }

  /* eslint jsx-a11y/href-no-hash: "off" */
  render() {
    return (
      <a
        href="#"
        className={`pointer-on-hover button block large ${this.getCategoryClass()}`}
        onClick={this.handleClick.bind(this)}
      >
        <span className="button--text">
          {this.props.text}
        </span>
      </a>
    );
  }
}

export default LobbyCTA;



// WEBPACK FOOTER //
// ./src/b5-home/LobbyCTA.js